const truncateText = (text, num) => {
    if (text && num && text.length > num) {
        if (num > 10) return text.substr(0, num - 10) + '...' + text.substr(-10)
        else return text.substr(0, num) + '...'
    }
    return text
}

export default truncateText